export const GTM_EVENT_ACTION_DOSSIER = 'dossier';
